import React from "react";
import { Paper } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import Typography from "@material-ui/core/Typography";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineDot from "@material-ui/lab/TimelineDot";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";

export const AmlWarningsDetails = ({ item }) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: "6px 16px",
    },
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main,
    },
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      {item?.Note ? (
        <div className={"col-md-12"}>
          <h4>Note</h4>
          <p>{item.Note}</p>
        </div>
      ) : undefined}
      {item?.BrokenRules?.length > 0 ? (
        <div className={"col-md-12"}>
          <h4>Broken rules</h4>
          {item?.BrokenRules?.map((itemToRender, index) => {
            return (
              <div className={"col-md-4"} key={index}>
                <b>{index + 1}.</b> {itemToRender.Name}:{" "}
                {itemToRender.Description} <br />
              </div>
            );
          })}
        </div>
      ) : undefined}
      {item?.actions?.fetching ? (
        <CircularProgress />
      ) : (
        <div className={"col-md-12"}>
          <h4>Status change history</h4>
          <Timeline align="alternate">
            {item?.actions?.data?.map((itemToRender, index) => {
              return (
                <TimelineItem key={index}>
                  <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                      <b>Created</b>: {itemToRender.Created}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paper}>
                      <Typography variant="h6" component="h4">
                        <b>Status</b>: {itemToRender.Status}
                      </Typography>
                      <b>Created by</b>: {itemToRender.CreatedBy} <br />
                      {itemToRender.Note && (
                        <span>
                          <b>Note</b>: {itemToRender.Note} <br />
                        </span>
                      )}
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </div>
      )}
    </React.Fragment>
  );
};
